export const winnerOf = (result) => {
  const runners = Array.isArray(result?.results) ? result.results : [];
  const winner = result?.winner || result?.roundWinner || runners.find((item) => item?.result === "WINNER")?.runnerName;
  return typeof winner === "string" ? winner.trim().toUpperCase() : "";
};

export const normalizeHeadsTailsResults = (response) => {
  const results = Array.isArray(response) ? response : response?.data;
  if (!Array.isArray(results)) throw new Error("Unrecognized results response");
  return results.filter((result) => result && typeof result === "object").slice(0, 10);
};
